// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    basisForSettlement: t.Bool,
    companyContribution: t.Bool,
    complaintCause: t.Bool,
    complaintCorrection: t.Bool,
    customerContribution: t.Bool,
    dealerContribution: t.Bool,
    downtime: t.Bool,
    failureArea: t.Bool,
    failureDate: t.Bool,
    failureMode: t.Bool,
    failurePart: t.Bool,
    installedBy: t.Bool,
    model: t.Bool,
    operatorsComplaint: t.Bool,
    ownershipStatus: t.Bool,
    pin: t.Bool,
    previousInvoiceNumber: t.Bool,
    repairDate: t.Bool,
    responsibleAccount: t.Bool,
    retailInstallDate: t.Bool,
    serialNumber: t.Bool,
    spaType: t.Bool,
    useAmount: t.Bool,
    useAmountUnit: t.Bool,
    workOrderOne: t.Bool
}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    basisForSettlement: true,
    companyContribution: true,
    complaintCause: true,
    complaintCorrection: true,
    customerContribution: true,
    dealerContribution: true,
    downtime: true,
    failureArea: true,
    failureDate: true,
    failureMode: true,
    failurePart: true,
    installedBy: true,
    model: true,
    operatorsComplaint: true,
    ownershipStatus: true,
    pin: true,
    previousInvoiceNumber: true,
    repairDate: true,
    responsibleAccount: true,
    retailInstallDate: true,
    serialNumber: true,
    spaType: true,
    useAmount: true,
    useAmountUnit: true,
    workOrderOne: true
});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/claim/spa/state/form-validation.js